import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ConfigContext, Drawer, Layout } from "@pionex-web-kit/components";
import { IconDarkMode20pxRegular, IconLightMode20pxRegular, IconStaff20pxRegular } from "@pionex-web-kit/icons";
import BasicLayout from "./../BasicLayout";
import { MenuOutlined } from "@ant-design/icons";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import ReactDOM from "react-dom";
import { createUseContext, useTheme } from "@pionex-web-kit/common-business";
import { findMenuNode } from "../BasicLayout/BasicSider";
import React from "react";
import { useTranslators } from "../hooks/Locale";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var _createUseContext = createUseContext({
    layout: {
      isHideHeader: false
    },
    setLayout: function setLayout() {}
  }),
  _createUseContext2 = _slicedToArray(_createUseContext, 2),
  LayoutProvider = _createUseContext2[0],
  useLayoutContext = _createUseContext2[1];
export default function ProLayout(_ref) {
  var menus = _ref.menus,
    children = _ref.children,
    openHelpCenter = _ref.openHelpCenter,
    footer = _ref.footer,
    className = _ref.className,
    siderClassName = _ref.siderClassName,
    mobileDrawerSiderClassName = _ref.mobileDrawerSiderClassName,
    contentClassName = _ref.contentClassName;
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("pro-layout");
  var menuNode = useMemo(function () {
    var paths = findMenuNode(menus, pathname);
    return paths[paths.length - 1];
  }, [menus, pathname]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileMenuDrawerVisible = _useState2[0],
    setMobileMenuDrawerVisible = _useState2[1];
  var open = useCallback(function () {
    setMobileMenuDrawerVisible(true);
  }, []);
  var close = useCallback(function () {
    setMobileMenuDrawerVisible(false);
  }, []);
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 2),
    theme = _useTheme2[0],
    setTheme = _useTheme2[1];
  var _useState3 = useState({
      isHideHeader: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    layout = _useState4[0],
    setLayout = _useState4[1];
  var mergeFooter = useMemo(function () {
    if (footer) {
      return footer;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "".concat(prefixCls, "-sider-footer"),
      children: [!!openHelpCenter && /*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-sider-footer-item"),
        children: /*#__PURE__*/_jsxs("div", {
          className: "".concat(prefixCls, "-sider-footer-item-content"),
          onClick: openHelpCenter,
          children: [/*#__PURE__*/_jsx(IconStaff20pxRegular, {
            size: 20
          }), " ", $st("manual_service_title")]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-sider-footer-item"),
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-sider-footer-item-content"),
          onClick: function onClick() {
            setTheme({
              theme: theme.theme === "light" ? "dark" : "light",
              ticker: theme.ticker
            });
          },
          children: theme.theme === "dark" ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(IconLightMode20pxRegular, {
              size: 20
            }), " ", $st("light_mode")]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(IconDarkMode20pxRegular, {
              size: 20
            }), " ", $st("dark_mode")]
          })
        })
      })]
    });
  }, [footer, theme, $st]);
  return /*#__PURE__*/_jsx(LayoutProvider, {
    value: {
      layout: layout,
      setLayout: setLayout
    },
    children: /*#__PURE__*/_jsxs(BasicLayout, {
      className: classNames(prefixCls, className),
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-sider-wrap"),
        children: /*#__PURE__*/_jsx(BasicLayout.BasicSider, {
          className: classNames("".concat(prefixCls, "-sider"), siderClassName),
          menus: menus,
          footer: mergeFooter
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-main"),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "".concat(prefixCls, "-mobile-title-wrap"),
          children: [/*#__PURE__*/_jsxs("div", {
            className: "".concat(prefixCls, "-mobile-title"),
            children: [/*#__PURE__*/_jsx(MenuOutlined, {
              size: 18,
              onClick: open
            }), !layout.isHideHeader && /*#__PURE__*/_jsx("span", {
              children: menuNode === null || menuNode === void 0 ? void 0 : menuNode.name
            }), /*#__PURE__*/_jsx("span", {
              id: "mobile-title-label"
            })]
          }), /*#__PURE__*/_jsx("div", {
            id: "mobile-title-extra"
          })]
        }), /*#__PURE__*/_jsx(Layout.Content, {
          className: contentClassName,
          children: children
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        placement: "left",
        title: null,
        width: 240,
        closable: false,
        className: classNames("".concat(prefixCls, "-drawer"), mobileDrawerSiderClassName),
        onClose: close,
        visible: mobileMenuDrawerVisible,
        children: /*#__PURE__*/_jsx(BasicLayout.BasicSider, {
          menus: menus,
          fixed: false,
          onMenuClick: close
        })
      })]
    })
  });
}
export function RenderMobileTitle(_ref2) {
  var children = _ref2.children,
    isClear = _ref2.isClear;
  var _useState5 = useState(document.querySelector("#mobile-title-label")),
    _useState6 = _slicedToArray(_useState5, 2),
    dom = _useState6[0],
    setDom = _useState6[1];
  var _useLayoutContext = useLayoutContext(),
    setLayout = _useLayoutContext.setLayout;
  useEffect(function () {
    var onChange = function onChange() {
      if (!dom) {
        setDom(document.querySelector("#mobile-title-label"));
      }
    };
    var observer = new MutationObserver(onChange);
    observer.observe(document, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
      setLayout(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          isHideHeader: false
        });
      });
    };
  }, []);
  useEffect(function () {
    if (isClear) {
      setLayout(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          isHideHeader: isClear
        });
      });
    }
  }, [isClear]);
  if (dom) {
    return /*#__PURE__*/ReactDOM.createPortal(children, dom);
  }
  return /*#__PURE__*/_jsx(_Fragment, {});
}
ProLayout.RenderMobileTitle = RenderMobileTitle;